import { useCallback, useEffect, useState } from "react";
import { fetchHospitalDashboard } from "../api/hospitalApi";
import {
  mapHospitalDashboardResponse,
  type HospitalDashboardViewData,
} from "../api/mapHospitalDashboard";
import { hospitalDashboardData } from "../data/hospitalDashboard";
import { getAuthToken } from "../auth";

export function useHospitalDashboard() {
  const [data, setData] = useState<HospitalDashboardViewData>(hospitalDashboardData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [usingApi, setUsingApi] = useState(false);

  const load = useCallback(async () => {
    if (!getAuthToken()) {
      setUsingApi(false);
      setData(hospitalDashboardData);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    setUsingApi(true);

    try {
      const response = await fetchHospitalDashboard();
      setData(mapHospitalDashboardResponse(response));
    } catch (err) {
      const message = err instanceof Error ? err.message : "Impossible de charger le dashboard.";
      setError(message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, error, usingApi, reload: load };
}
